import { combineReducers } from "redux";

import { userMananementReducer } from "./components/user-management/user-management-store";
import { companyInformationReducer } from "./components/company-information/company-information-store";
import { invoiceHistoryReducer } from "./components/invoice-history/invoice-history-store";

export const informationPageReducer = combineReducers({ userMananementReducer, companyInformationReducer, invoiceHistoryReducer });
